import { useEffect, useState } from 'react';

// graphql
import { usePawGetChipsSummaryQuery, useCashierProfileQuery } from '@/generated/graphql';

// components
import { CashChipsSummary } from './components/cash-chips-summary/cash-chips-summary';
import { PlayerTransactions } from './components/player-transactions/player-transactions';

// helpers
import { formatNumber } from '@/shared/constants';

export const PlayerAdditionWithdrawalsPage = () => {
  const [cashBalance, setCashBalance] = useState('0');
  const [chipsBalance, setChipsBalance] = useState('0');

  const pawGetChipsSummaryQuery = usePawGetChipsSummaryQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setTimeout(() => {
        setChipsBalance(formatNumber(data.chipsSummary?.cashiersChips));
      }, 100);
    },
  });

  const cashierProfileQuery = useCashierProfileQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setTimeout(() => {
        setCashBalance(formatNumber(data.cashierProfile?.cashBalance));
      }, 100);
    },
  });

  const refetch = () => {
    pawGetChipsSummaryQuery.refetch();
    cashierProfileQuery.refetch();
  };

  return (
    <div>
      <CashChipsSummary cashBalance={cashBalance} chipsBalance={chipsBalance} />
      <PlayerTransactions refetch={refetch} />
    </div>
  );
};
